module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/script-01-62d58f2fa7b0e0f1730e1ba6fcfa5eaa.svg";